
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ReportsAPI from '../services/reportsAPI';
import ModernTable from '../components/common/ModernTable';
import styles from './CompletedVoyageReport.module.css';

function formatLocalDate(dateStr) {
  if (!dateStr) return '-';
  const d = new Date(dateStr);
  if (isNaN(d)) return '-';
  return d.toLocaleDateString();
}

const columns = [
  { key: 'container_number', label: 'Container Number' },
  { key: 'location', label: 'Location' },
  {
    key: 'empty_return_date',
    label: 'Empty Return Date',
    render: (val) => formatLocalDate(val)
  },
  { key: 'empty_free_days', label: 'Empty Free Days Allowed' },
  { key: 'total_storage_days', label: 'Total Storage Days' },
  { key: 'excess_storage_days', label: 'Excess Storage Days' },
];

const ContainerDwellTimeReport = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');

  // For Excel download
  const XLSX = require('xlsx');
  // Excel download handler
  const handleDownloadExcel = () => {
    const dataToExport = filteredData.map(row => ({
      'Container Number': row.container_number,
      'Location': row.location,
      'Empty Return Date': formatLocalDate(row.empty_return_date),
      'Empty Free Days Allowed': row.empty_free_days,
      'Total Empty Days': row.total_storage_days,
      'Excess Storage Days': row.excess_storage_days
    }));
    const worksheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Dwell Time Report');
    XLSX.writeFile(workbook, 'ContainerDwellTimeReport.xlsx');
  };

  useEffect(() => {
    setLoading(true);
    setError(null);
    ReportsAPI.getDwellTimeReport()
      .then((res) => {
        setData(res.data);
        setLoading(false);
      })
      .catch((err) => {
        setError('Failed to fetch dwell time report');
        setLoading(false);
      });
  }, []);

  // Filter logic similar to DetentionReport
  const filteredData = React.useMemo(() => {
    if (!searchTerm.trim()) return data;
    const lowerSearch = searchTerm.toLowerCase();
    return data.filter(row =>
      (row.container_number && row.container_number.toLowerCase().includes(lowerSearch)) ||
      (row.location && row.location.toLowerCase().includes(lowerSearch)) ||
      (row.empty_return_date && formatLocalDate(row.empty_return_date).toLowerCase().includes(lowerSearch))
    );
  }, [data, searchTerm]);

  return (
    <div className={styles.completedVoyageReport}>
      <button onClick={() => navigate('/agent/dashboard')} className={styles.backButton}>
        &larr; Back to Dashboard
      </button>
      <h2 className={styles.heading}>Line Container Empty Free Days Report</h2>
      <div className={styles.searchRow}>
        <input
          type="text"
          placeholder="Search by container number, location, date..."
          value={searchTerm}
          onChange={e => setSearchTerm(e.target.value)}
          className={styles.searchInput}
        />
        <button onClick={handleDownloadExcel} className={"btn btn-sm btn-success " + styles.downloadButton}>
          Download this report
        </button>
      </div>
      {loading && <div className={styles.loading}>Loading...</div>}
      {error && <div className={styles.error}>{error}</div>}
  <ModernTable columns={columns} data={filteredData} />
    </div>
  );
};

export default ContainerDwellTimeReport;
